<template>
  <div class="table-list-root theme-pink">
    <div class="table-search-section list-section search-section">
      <Search :is-type="isType" :isShow="false" @searchData="searchData"></Search>
    </div>
    <div class="table-body-section list-section table-section">
      <el-tabs class="list-tabs" @tab-click="handleClick" v-model="activeName">
        <el-tab-pane :label="`可报名(${allcount.able_count})`" name="able"
                     v-if="allcount.able_count!==undefined"></el-tab-pane>
        <el-tab-pane :label="`我的报名(${allcount.mine_count})`" name="mine"
                     v-if="allcount.mine_count!==undefined"></el-tab-pane>
        <el-tab-pane :label="`已初选的(${allcount.employ_count})`" name="employ"
                     v-if="allcount.employ_count!==undefined"></el-tab-pane>
        <el-tab-pane :label="`已合作的(${allcount.confirm_count})`" name="confirm"
                     v-if="allcount.employ_count!==undefined"></el-tab-pane>
      </el-tabs>
      <div class="default-table table-wrap" ref="tableWrap">
        <el-table :data="tableData" class="inquiry-table" :height="tableBodyHeight" style="width: 100%">
          <el-table-column
            align="center"
            label="序号"
            type="index"
            width="60"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="创建日期"
            prop="created_at"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="项目名称"
            min-width="200"
            prop="name"
            show-overflow-tooltip
          >
            <template slot-scope="{row}">
              <div class="project-cell">
                <div class="project-name-line">
                  <el-link @click="detailPage(row.id)" size="mini"
                           class="project-link"
                           :title="row.name"
                           v-if="userPermissions.indexOf('inquiry_apply_detail') !== -1">
                    {{ row.name }}
                  </el-link>
                  <span v-else class="project-name" :title="row.name">{{ row.name }}</span>
                </div>
                <div class="project-sub" v-if="formatIntentions(row.intentions)">
                  意向达人: {{ formatIntentions(row.intentions) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="品牌"
            prop="brand"
            show-overflow-tooltip
            width="100"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="产品"
            prop="product"
            show-overflow-tooltip
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="直播平台"
            min-width="200"
          >
            <template slot-scope="{row}">
              <div v-if="formatPlatforms(row.platforms).length" class="platform-list">
                <span v-for="(platform, idx) in formatPlatforms(row.platforms).slice(0, 3)" :key="idx"
                      class="platform-chip">{{ platform }}</span>
                <span v-if="formatPlatforms(row.platforms).length > 3" class="platform-more">...</span>
              </div>
              <span v-else class="muted">-</span>
            </template>
          </el-table-column>
          <el-table-column
            align='center'
            min-width="110"
            label='是否平台下单'
            prop='is_platform_pay'
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align='center'
            label='直播机制'
            prop='live_mec'
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align='center'
            label='是否保量'
            prop='is_quantity'
            min-width="90"
            show-overflow-tooltip
          >
            <template slot-scope='{row}'>
              {{ row.is_quantity === 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column
            label="期望档期"
            align="center"
            prop="expect_start"
            min-width="180"
            show-overflow-tooltip
          >
            <template slot-scope="{row}">
              <span class="date-range">{{ row.expect_start.slice(0, 10) }} 至 {{ row.except_end.slice(0, 10) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="项目状态" prop="status"
            show-overflow-tooltip
            width="110"
          >
            <template slot-scope='{row}'>
              <el-tag
                :type="row?.status == 1 ?'success':'danger'"
                effect="plain">
                {{
                  row?.status == 1 ? '进行中' : row?.status == 2 ? '已结束' : row?.status == 3 ? '已作废' : '已完结'
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" fixed="right" label="操作" width="110">
            <template slot-scope="{row}">
              <el-button
                @click="detailPage(row.id)"
                size="mini"
                type="primary"
                v-if="userPermissions.indexOf('inquiry_apply_detail') !== -1">
                {{ activeName == 'able' ? '报名' : '查看' }}
              </el-button>
              <span v-else class="muted">-</span>
            </template>
          </el-table-column>
        </el-table>
        <el-row ref="paginationWrap">
          <el-col :span="24" class="text-right">
            <Pagination :limit.sync="tablePagination.page_size"
                        :page.sync="tablePagination.current_page"
                        :total="tablePagination.total"
                        @pagination="infoData"/>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Search from './components/search'
import InfoDetail from './InfoDetail'
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import { mapGetters } from 'vuex'

export default {
  name: 'yearEnrollInquiryList',
  components: { Search, InfoDetail, PageHeaderLayout },
  data() {
    return {
      tableData: [],
      drawerVisible: false,
      rowId: 'add',
      activeName: 'mine',
      tableBodyHeight: 360,
      tablePagination: {
        total: 0,
        page_size: 15,
        offset: 0,
        current_page: 1
      },
      allcount: {},
      searchDatas: {},
      isType: false
    }
  },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo'])
  },
  watch: {
    drawerVisible: {
      handler(val) {
        if (!val) {
          this.infoData()
        }
      }
    }
  },
  methods: {
    handleClick() {
      this.infoData()

    },
    updateTableLayout() {
      this.$nextTick(() => {
        const tableWrap = this.$refs.tableWrap
        const paginationWrap = this.$refs.paginationWrap
        if (!tableWrap) {
          return
        }
        const nextTableHeight = Math.max(
          220,
          tableWrap.clientHeight - (paginationWrap ? paginationWrap.offsetHeight : 0)
        )
        if (nextTableHeight !== this.tableBodyHeight) {
          this.tableBodyHeight = nextTableHeight
        }
      })
    },
    bindTableLayout() {
      if (this.tableResizeObserver) {
        return
      }
      if (typeof ResizeObserver !== 'undefined' && this.$refs.tableWrap) {
        this.tableResizeObserver = new ResizeObserver(() => {
          this.updateTableLayout()
        })
        this.tableResizeObserver.observe(this.$refs.tableWrap)
      }
      window.addEventListener('resize', this.updateTableLayout)
    },
    unbindTableLayout() {
      if (this.tableResizeObserver) {
        this.tableResizeObserver.disconnect()
        this.tableResizeObserver = null
      }
      window.removeEventListener('resize', this.updateTableLayout)
    },
    searchData(val) {
      this.searchDatas = val
      const cond = {}
      const name = ['name', 'status', 'brand', 'created_start', 'created_end', 'expect_start', 'expect_end', 'is_apply']
      name.forEach((type) => {
        if (val[type] != '') {
          cond[type] = val[type]
        }
      })
      if (val.intentions?.length != 0) {
        cond['intentions'] = val.intentions
      }
      if (val.platforms?.length != 0) {
        cond['platforms'] = val.platforms
      }
      this.searchDatas = cond
      this.infoData()
    },

    async infoData() {
      const searchCondition = this.searchDatas
      Object.assign(searchCondition, {
        page_size: this.tablePagination.page_size || 15,
        current_page: this.tablePagination.current_page || 1
      }, { case_type: this.activeName })
      searchCondition.type = this.isType ? 1 : 2
      const { list, page_info } = await this.$api.listApplyInquiry(searchCondition)

      // applyCount
      this.$nextTick(() => {
        const convertData = ['is_assign', 'is_platform_pay', 'is_send_back', 'is_cart', 'is_auth_price']
        list.forEach((item) => {
          convertData.forEach((i) => {
            if (i === 'is_assign' || i === 'is_send_back') {
              item[i] = item[i] == 1 ? '是' : '否'
            } else item[i] = item[i] == 1 ? '否' : '是'
          })
        })
        this.tableData = list
        this.tablePagination = page_info

      })
    },
    async getCountData() {
      this.allcount = await this.$api.applyCount({ type: 2 })
    },
    detailPage(id) {
      this.$router.push({
        name: 'enrollDetail',
        params: { id: id }
      })
    },
    formatPlatforms(platforms) {
      if (Array.isArray(platforms)) {
        return platforms
          .map((p) => (p && typeof p === 'object' ? (p.platform_name || p.display_name || p.name || '') : String(p)))
          .filter(Boolean)
      }
      if (typeof platforms === 'string') {
        return platforms.split(/[,，、/]/).map((s) => s.trim()).filter(Boolean)
      }
      return []
    },
    formatIntentions(intentions) {
      if (!Array.isArray(intentions)) {
        return ''
      }
      return intentions
        .map((item) => (item && typeof item === 'object' ? (item.nickname || item.display_name || item.name || '') : String(item)))
        .filter(Boolean)
        .join('、')
    },
    moneyFormat(value) {
      return this.$utils.numberFormat(value, 2, '.', ',', 'round')
    }
  },
  mounted() {
    this.infoData()
    this.getCountData()
    this.$nextTick(() => {
      this.updateTableLayout()
      this.bindTableLayout()
    })
  },
  beforeDestroy() {
    this.unbindTableLayout()
  }
}
</script>

<style lang='scss' scoped>
/* ===== 粉色主题（对齐 /inquiries/list 列表样式） ===== */
.table-list-root.theme-pink {
  --list-accent: #ff3176;
  --list-accent-soft: rgba(255, 49, 118, 0.10);
  padding: 10px;
  height: 100%;
  overflow: hidden;
  background: #f3f5fa;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.theme-pink .list-section {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 7px rgba(16, 24, 40, 0.05);
}

.theme-pink .search-section {
  padding: 14px 16px 0;
}

.theme-pink .table-section {
  padding: 0 16px 16px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 240px);
  min-height: 420px;
}

.theme-pink .table-wrap {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.theme-pink ::v-deep .search-section .el-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 10px;
}

.theme-pink ::v-deep .search-section .el-form-item {
  margin: 0 0 10px;
}

.theme-pink ::v-deep .search-section .el-input__inner,
.theme-pink ::v-deep .search-section .el-cascader .el-input__inner {
  height: 32px;
  border-color: #e3e8f2;
  border-radius: 6px;
  background: #f8fafc;
}

.theme-pink ::v-deep .search-section .el-input__inner:focus {
  border-color: var(--list-accent);
  background: #fff;
}

.theme-pink ::v-deep .search-section hr {
  display: none;
}

.theme-pink ::v-deep .search-section .el-button--primary,
.theme-pink ::v-deep .table-section .el-button--primary {
  border: none;
  border-radius: 8px;
  background: var(--list-accent);
  color: #fff;
  box-shadow: 0 6px 14px rgba(255, 49, 118, 0.20);
}

.theme-pink ::v-deep .list-tabs .el-tabs__header {
  margin: 0 0 12px;
}

.theme-pink ::v-deep .list-tabs .el-tabs__nav-wrap::after {
  height: 1px;
  background: #edf1f7;
}

.theme-pink ::v-deep .list-tabs .el-tabs__item {
  color: #667085;
  font-weight: 600;
}

.theme-pink ::v-deep .list-tabs .el-tabs__item.is-active {
  color: var(--list-accent);
}

.theme-pink ::v-deep .list-tabs .el-tabs__active-bar {
  background: var(--list-accent);
}

.theme-pink ::v-deep .inquiry-table {
  color: #334155;
  font-size: 13px;
  flex: 0 0 auto;
}

.theme-pink ::v-deep .inquiry-table::before {
  display: none;
}

.theme-pink ::v-deep .inquiry-table th.el-table__cell {
  background: #f8fafc;
  color: #8793a8;
  font-weight: 700;
}

.theme-pink ::v-deep .inquiry-table thead th .cell,
.theme-pink ::v-deep .inquiry-table thead th.is-leaf .cell {
  height: 30px !important;
  line-height: 30px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  color: #8793a8 !important;
}

.theme-pink ::v-deep .default-table .el-table thead tr,
.theme-pink ::v-deep .default-table .el-table thead th {
  background-color: #f8fafc !important;
  color: #8793a8;
  font-weight: 700;
}

.theme-pink ::v-deep .inquiry-table td.el-table__cell,
.theme-pink ::v-deep .inquiry-table th.el-table__cell {
  border-bottom: 1px solid #edf1f7;
}

.theme-pink ::v-deep .inquiry-table .el-table__fixed-right::before {
  display: none;
}

.theme-pink ::v-deep .default-table .el-table--border,
.theme-pink ::v-deep .default-table .el-table--border::after {
  border-color: #edf1f7;
}

.theme-pink ::v-deep .default-table .el-table--border th.el-table__cell,
.theme-pink ::v-deep .default-table .el-table--border td.el-table__cell {
  border-right: 1px solid #edf1f7;
}

.theme-pink .project-cell {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.theme-pink .project-name-line {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
}

.theme-pink .project-sub {
  color: #8a96ab;
  font-size: 12px;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.theme-pink .project-link,
.theme-pink .project-name {
  color: #ff3176;
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.theme-pink .primary-text {
  color: #0f172a;
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.theme-pink .project-link {
  max-width: 100%;
}

.theme-pink .platform-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
}

.theme-pink .platform-chip {
  height: 26px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #e3e8f2;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  line-height: 24px;
}

.theme-pink .platform-more {
  height: 26px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  border-radius: 8px;
  background: #fff0f5;
  color: #ff3176;
  font-size: 13px;
  font-weight: 700;
  line-height: 24px;
}

.theme-pink .muted {
  color: #8a96ab;
  font-size: 12px;
}

.theme-pink .date-range {
  color: #475569;
  font-weight: 600;
}

.theme-pink ::v-deep .default-table .el-row {
  padding-top: 12px;
}

@media (max-width: 1200px) {
  .theme-pink .list-section {
    padding: 12px;
  }
}
</style>
